export enum RELOAD_TYPES {
  //order
  Contractors = "Contractors",
  OrderItems = "OrderItems",
  Owners = "Owners",
  Order = "Order",
  Comment = "Comment",
  ContractorMonit = "ContractorMonit",
  OrderItemMonit = "OrderItemMonit",
  CorrectionReason = "CorrectionReason",

  //booking
  BookingItem = "BookingItem",
  BookingItemAttribute = "BookingItemAttribute",
  File = "File",
  Booking = "Booking",
  Contractor = "Contractor",
  BookingItemTradeTerm = "BookingItemTradeTerm",
  AgentCreditCards = "AgentCreditCards",
  BookingContractorMonit = "BookingContractorMonit",
  BookingFormOfPayments = "BookingFormOfPayments",

  //costDocumentOther
  Files = "Files",
  //Contractor = "Contractor",
  Details = "Details",
  Items = "Items",
  Attributes = "Attributes",
  PayerBankAccounts = "PayerBankAccounts",

  //contract
}
